import {get} from 'lodash';

export const getNielsenMeta = (ad_data, pageCounter, referrerUrl) => {
  if (!ad_data) {
    return {};
  }

  const edition = get(ad_data, 'ad_edition');
  const pageId = get(ad_data, 'ad_pageid');
  const section = get(ad_data, 'ad_category_path') || 'Refinery29 - Other';
  const data = {
    type: 'static',
    assetid: `${edition}/${pageId}`,
    section: section
  };

  if (pageCounter > 0) {
    data.pageURL = 'page_' + pageCounter + '_' + window.location.href;
    data.referrerURL = referrerUrl;
  }

  return data;
};

/**
 * Logic for pageURL and referrerURL is as follows:
 * - On first page load: pageURL and referrerURL are not passed
 * - On first single page app click: pageURL = `page_1_{url}`, referrerURL = first page load url
 * - On second single page app click: pageURL = `page_2_{url}`, referrerURL = `page_1_{url}`
 */
export const sendNielsenPageview = (ad_data) => {
  if (!get(window, 'NOLBUNDLE.Nielsen.ggPM')) {
    return;
  }

  window.nielsenData = window.nielsenData || {
    pageCounter: 0,
    initialPageUrl: window.location.href,
    meta: {}
  };

  if (window.nielsenData.pageCounter > 0) {
    window.NOLBUNDLE.Nielsen.ggPM('staticend', window.nielsenData.meta);
  }

  const referrerUrl = window.nielsenData.meta.pageURL || window.nielsenData.initialPageUrl;
  window.nielsenData.meta = getNielsenMeta(ad_data, window.nielsenData.pageCounter, referrerUrl);
  window.NOLBUNDLE.Nielsen.ggPM('staticstart', window.nielsenData.meta);
  window.nielsenData.pageCounter++;
};
